import styled from "styled-components";
import {themecolors} from "../utils/themecolors";

const AppContainer = styled.div`
  width: 100%;
  ${({theme}) => `
    color: ${theme.main.color}; 
    background-color: ${theme.color.name === 'dark' ? themecolors.dark_background_1 : '#fff'};
    label, input[type=text], input[type=password] {
        color: ${theme.label.color};
    }
    
    .react-loading-skeleton {
        background-color: ${theme.color.name === 'dark' ? themecolors.dark_background_5 : themecolors.light_input};
        background-image: none;
    }
    
    input[type="file"] {
      border: none;
    }
  `}
`;

export default AppContainer;
